// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 871) return "static/chunks/871-20234606eb75db13.js";
	if (chunkId === 2093) return "static/chunks/2093-92511966a2df6ce8.js";
	if (chunkId === 8027) return "static/chunks/8027-12450eafc4869a68.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7646 ? "a3319169" : chunkId) + "." + {"5959":"4a1dc9fc50f396ac","7646":"aaabdd128b988942","9331":"4262dc13efa390d2"}[chunkId] + ".js";
};